import { render, staticRenderFns } from "./PlaceOrderSh.vue?vue&type=template&id=86d45fc0&scoped=true&"
import script from "./PlaceOrderSh.vue?vue&type=script&lang=js&"
export * from "./PlaceOrderSh.vue?vue&type=script&lang=js&"
import style0 from "./PlaceOrderSh.vue?vue&type=style&index=0&id=86d45fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d45fc0",
  null
  
)

export default component.exports